import React from "react";
import logo from "../assets/logo/logo-white.png";

const Header = () => {
  return (
    <header className="header">
      <img src={logo} alt="Infobizz" className="logo" />

      <nav>
        <ul className="nav">
          <li><a href="#home">Home</a></li>
          <li><a href="#about">About</a></li>
          <li><a href="#services">Services</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
